var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "26.0878mm",
    height: "5.4346mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 26087.8 5434.6",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M2717.2 5434.6c-1500.4,-0.1 -2717.2,-1216.9 -2717.2,-2717.3 0,-1500.5 1216.8,-2717.3 2717.3,-2717.3 1500.5,0 2717.3,1216.8 2717.3,2717.3 -1.3,1499.9 -1217.3,2715.9 -2717.2,2717.2l-0.2 0.1zm0 -5212.3c-1377.6,0 -2494.9,1117.3 -2494.9,2495 0,1377.6 1117.3,2494.9 2495,2494.9 1377.7,0 2495,-1117.3 2495,-2494.9 -1.1,-1377.2 -1117.8,-2493.9 -2494.9,-2495.1l-0.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M13099.5 5434.6c-1500.4,-0.1 -2717.2,-1216.9 -2717.2,-2717.3 0,-1500.5 1216.8,-2717.3 2717.1,-2717.3 1500.5,0 2717.3,1216.8 2717.3,2717.3 -1.4,1499.9 -1217.4,2715.9 -2717.3,2717.2l0.1 0.1zm0 -5212.3c-1377.6,0 -2494.9,1117.3 -2494.9,2495 0,1377.6 1117.3,2494.9 2494.8,2494.9 1377.7,0 2495,-1117.3 2495,-2494.9 -1.2,-1377.2 -1117.9,-2493.9 -2495,-2495.1l0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M23370.6 5434.6c-1500.6,-0.1 -2717.4,-1216.9 -2717.4,-2717.3 0,-1500.5 1216.8,-2717.3 2717.3,-2717.3 1500.5,0 2717.3,1216.8 2717.3,2717.3 0,1500.4 -1216.8,2717.2 -2717.3,2717.2l0.1 0.1zm0 -5212.3c-1377.8,0 -2495.1,1117.3 -2495.1,2495 0,1377.6 1117.3,2494.9 2495,2494.9 1377.7,0 2495,-1117.3 2495,-2494.9 -1.2,-1377.2 -1117.9,-2493.9 -2495,-2495.1l0.1 0.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    fillRule: "nonzero",
    points: "8302.6,1375.9 8302.6,2516.2 9411.2,2516.2 9411.2,3095.7 8302.6,3095.7 8302.6,4233.4 7672.9,4233.4 7672.9,3095.7 6559,3095.7 6559,2516.2 7672.9,2516.2 7672.9,1375.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    fillRule: "nonzero",
    points: "18436.1,1375.9 18436.1,2516.2 19547.4,2516.2 19547.4,3095.7 18436.1,3095.7 18436.1,4233.4 17798.5,4233.4 17798.5,3095.7 16695.2,3095.7 16695.2,2516.2 17798.5,2516.2 17798.5,1375.9 "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc32);
export default __webpack_public_path__ + "static/media/ic_3_2.7f00f0c451268c73b7ff58958fb123a2.svg";
export { ForwardRef as ReactComponent };